import { TRACKING_PERMISSIONS_REQUEST } from '../Notifications/constants';
import SectionIds from './SectionIds';

export const TRACK_CATEGORIES = {
  CLICKOUT: 'clickout',
  SEARCH: 'search',
  INTERACTIONS: 'interactions',
  FILTERS: 'filters',
  NOTIFICATIONS: 'notifications',
  ADPAGE: 'adpage',
};

export const TRACK_ACTIONS = {
  CLICKOUT: 'clickout',
  IMPRESSION: 'impression',
  ADPAGE_CLICKOUT: 'adpage_clickout',
  ADPAGE_CLICKIN: 'adpage_clickin',
  ADPAGE_CLICKIN_FORM: 'adpage_form_clickin',
  ADPAGE_SAVE_APPLY: 'save_apply',
  SORT: 'sort',
  SCROLLED: 'scrolled',
  NO_SCROLLED: 'no_scrolled',
  RESET: 'reset',
  SHOW_FILTERS: 'show_filters',
  CLOSE_FILTERS: 'close_filters',
  NOTIFICATIONS_PERMISSIONS: 'permissions',
  NOTIFICATIONS_STATUSES: 'statuses',
  NOTIFICATIONS_SAVE_ALERT: 'save_alert',
  NOTIFICATIONS_ALERTBOX_IMPRESSION: 'alertbox_impression',
};

export const TRACK_LABELS = {
  VISIT_SOURCE: 'visit_source',
  RELATED_ADS: 'related_ads',
  NOT_FOUND: 'not_found',
  NAVIGATOR: 'navigator',
  LEADS_FORM: 'leads_form',
  EXPIRED_AD: 'expired_ad',
  CHANNEL_SELECTION_BANNER: 'channel_selection_banner',
  CHANNEL_SELECTION_ALERTBOX: 'channel_selection_alertbox',
  FEATURED_AD: 'featured_ad',
};

export const clickoutEvent = adUrl => ({
  category: TRACK_CATEGORIES.CLICKOUT,
  action: TRACK_ACTIONS.CLICKOUT,
  label: adUrl,
});

export const adPageClickoutEvent = adUrl => ({
  category: TRACK_CATEGORIES.CLICKOUT,
  action: TRACK_ACTIONS.ADPAGE_CLICKOUT,
  label: adUrl,
});

export const clickinEvent = adId => ({
  category: TRACK_CATEGORIES.CLICKOUT,
  action: TRACK_ACTIONS.ADPAGE_CLICKIN,
  label: adId,
  nonInteraction: true,
});

export const clickinFormEvent = adId => ({
  category: TRACK_CATEGORIES.CLICKOUT,
  action: TRACK_ACTIONS.ADPAGE_CLICKIN_FORM,
  label: adId,
  nonInteraction: true,
});

export const navigatorClickinEvent = () => ({
  category: TRACK_CATEGORIES.CLICKOUT,
  action: TRACK_ACTIONS.ADPAGE_CLICKIN,
  label: TRACK_LABELS.NAVIGATOR,
  section: SectionIds.SECTION_PYA_ADPAGE_PAGINATOR_MLT,
  nonInteraction: true,
});

export const navigatorClickinFormEvent = () => ({
  category: TRACK_CATEGORIES.CLICKOUT,
  action: TRACK_ACTIONS.ADPAGE_CLICKIN_FORM,
  label: TRACK_LABELS.NAVIGATOR,
  section: SectionIds.SECTION_PYA_ADPAGE_PAGINATOR_MLT,
  nonInteraction: true,
});

export const searchSortEvent = sort => ({
  category: TRACK_CATEGORIES.SEARCH,
  action: TRACK_ACTIONS.SORT,
  label: sort,
});

export const scrolledInteractionEvent = () => ({
  category: TRACK_CATEGORIES.INTERACTIONS,
  action: TRACK_ACTIONS.SCROLLED,
  nonInteraction: true,
});

export const noscrolledInteractionEvent = () => ({
  category: TRACK_CATEGORIES.INTERACTIONS,
  action: TRACK_ACTIONS.NO_SCROLLED,
  nonInteraction: true,
});

export const filtersResetEvent = () => ({
  category: TRACK_CATEGORIES.FILTERS,
  action: TRACK_ACTIONS.RESET,
});

export const showFiltersInteractionEvent = () => ({
  category: TRACK_CATEGORIES.INTERACTIONS,
  action: TRACK_ACTIONS.SHOW_FILTERS,
});

export const closeFiltersInteractionEvent = () => ({
  category: TRACK_CATEGORIES.INTERACTIONS,
  action: TRACK_ACTIONS.CLOSE_FILTERS,
});

export const notificationPermissionsEvent = permission => ({
  category: TRACK_CATEGORIES.NOTIFICATIONS,
  action: TRACK_ACTIONS.NOTIFICATIONS_PERMISSIONS,
  label: permission,
  nonInteraction: permission === TRACKING_PERMISSIONS_REQUEST,
});

export const notificationStatusesEvent = (searchId, status, infrastructureId = null) => ({
  category: TRACK_CATEGORIES.NOTIFICATIONS,
  action: TRACK_ACTIONS.NOTIFICATIONS_STATUSES,
  label: status,
  searchId,
  infrastructureId,
  nonInteraction: true,
});

export const notificationAlertBoxImpressionEvent = what => ({
  category: TRACK_CATEGORIES.NOTIFICATIONS,
  action: TRACK_ACTIONS.NOTIFICATIONS_ALERTBOX_IMPRESSION,
  label: what,
  nonInteraction: true,
});

export const notFoundImpressionEvent = () => ({
  category: TRACK_CATEGORIES.SEARCH,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.NOT_FOUND,
  section: SectionIds.SECTION_SEARCH_RESULTS_NORESULT,
  nonInteraction: true,
});

export const notFoundKeywordsImpressionEvent = () => ({
  category: TRACK_CATEGORIES.SEARCH,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.NOT_FOUND,
  section: SectionIds.SECTION_SEARCH_RESULTS_KEYWORDS404,
  nonInteraction: true,
});

export const notFoundAdwordsImpressionEvent = () => ({
  category: TRACK_CATEGORIES.SEARCH,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.NOT_FOUND,
  section: SectionIds.SECTION_PAID_REGULARLANDING_ADS_NORESULTS,
  nonInteraction: true,
});

export const adpageAdImpressionEvent = adId => ({
  category: TRACK_CATEGORIES.ADPAGE,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.VISIT_SOURCE,
  section: SectionIds.SECTION_ADPAGE_VISIT_SOURCE,
  adId,
  nonInteraction: true,
});

export const adpageNavigatorImpressionEvent = () => ({
  category: TRACK_CATEGORIES.ADPAGE,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.NAVIGATOR,
  section: SectionIds.SECTION_PYA_ADPAGE_PAGINATOR_MLT,
  nonInteraction: true,
});

export const adpageFormImpressionEvent = adId => ({
  category: TRACK_CATEGORIES.ADPAGE,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.LEADS_FORM,
  value: adId,
  section: SectionIds.SECTION_ADPAGE_CONTACT_FORM,
  nonInteraction: true,
});

export const adpageRelatedAdsImpressionEvent = () => ({
  category: TRACK_CATEGORIES.ADPAGE,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.RELATED_ADS,
  section: SectionIds.SECTION_ADPAGE_SIMILAR,
  nonInteraction: true,
});

export const expiredAdImpressionEvent = () => ({
  category: TRACK_CATEGORIES.SEARCH,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.EXPIRED_AD,
  section: SectionIds.SECTION_EXPIREDAD,
  nonInteraction: true,
});

// Test AB for task PWA-1095 - More like this (Featured ad on top)
export const featuredAdImpressionEvent = () => ({
  category: TRACK_CATEGORIES.SEARCH,
  action: TRACK_ACTIONS.IMPRESSION,
  label: TRACK_LABELS.FEATURED_AD,
  section: SectionIds.SECTION_RETENTION_FEATURED,
});

// Test AB [PROD-283] - Disambiaguation tracking
export const disambiguationListImpressionEvent = () => ({
  category: 'PROD-283',
  action: TRACK_ACTIONS.IMPRESSION,
  nonInteraction: true,
});

// Test AB [PROD-283] - Disambiaguation tracking
export const disambiguationListNoImpressionEvent = () => ({
  category: 'PROD-283',
  action: `no_${TRACK_ACTIONS.IMPRESSION}`,
  nonInteraction: true,
});

// Test AB [PROD-283] - Disambiaguation tracking
export const disambiguationListClickEvent = () => ({
  category: 'PROD-283',
  action: 'click',
  nonInteraction: true,
});

// Test AB [PROD-283] - Disambiaguation tracking
export const disambiguationListRemoveFilterClickEvent = () => ({
  category: 'PROD-283',
  action: 'remove_filter',
  nonInteraction: true,
});



// WEBPACK FOOTER //
// ./app/tracking/events.js